<template>
  <div id="mc_embed_signup">
    <form action="https://covidbystate.us10.list-manage.com/subscribe/post?u=435c4b1ac6f82b935cc00bc21&amp;id=552a212034" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
      <div id="mc_embed_signup_scroll">
        <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="subscribe for updates" required />&nbsp;
        <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
        <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_435c4b1ac6f82b935cc00bc21_552a212034" tabindex="-1" value=""></div>
        <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
      </div>
    </form>
  </div>
</template>


<style scoped lang="scss">

    #mc_embed_signup {
      background:#D7D9E0;
      clear:left;
      font:14px Helvetica,Arial,sans-serif;
      width:100%;
    }

    @media (min-width: 320px) and (max-width: 1000px) {
      
      #mc_embed_signup {
        margin:0px auto;
        width:80%;
      }

    }


</style>

<script>
export default {

  name:'Signup'



}
</script>